import React, { useRef } from "react";

export const BarraComportamientoComponent = ({ element, prmtotal = false }) => {
  const formatmiles = (number) => {
    if (number <= 0) {
      number = 0;
    }
    return Math.floor((number ?? 0) / 1000).toLocaleString("en-US");
  };

  const calcPorcentaje = (importe, total) => {
    return Math.min((importe / total) * 100, 100);
  };

  const Getvalue = (estado) => {
    try {
      if (prmtotal === false) {
        var result = element.filter((item) => item.estado === estado)[0];
        return result.importe;
      } else {
        var result = element.filter((item) => item.estado === `${estado}`);
        return result.reduce((a, b) => a + b.importe, 0);
      }
    } catch {
      return 0;
    }
  };
  const total = Getvalue("A") + Getvalue("P") + Getvalue("V");

  const circuloARef = useRef(null);
  const circuloPVRef = useRef(null);
  const circuloVRef = useRef(null);
  const segmentoARef = useRef(null);
  const segmentoPVRef = useRef(null);
  const segmentoVRef = useRef(null);

  // console.log(calcPorcentaje(importeActivo, total))
  return (
    <div className="td-contenido">
      <div className="barra-progreso-wrapper">
        {/* <div className="porcentaje-texto-recuperado">
                                    $ {formatmiles(carteras.Operación.recuperado)}
                                </div> */}
        <div className="barra-monto">
          <div className="monto monto-activo" ref={circuloARef}>
            <span
              className="circulo"
              style={{ backgroundColor: "#4caf50" }}
            ></span>
            {/* <span>A: $ {formatmiles(importeActivo)}</span> */}
            <span>A: $ {formatmiles(Getvalue("A"))}</span>
          </div>
          <div className="monto monto-porvencer" ref={circuloPVRef}>
            <span
              className="circulo"
              style={{ backgroundColor: "#ffc107" }}
            ></span>
            <span>PV: $ {formatmiles(Getvalue("P"))}</span>
          </div>
          <div className="monto monto-vencido" ref={circuloVRef}>
            <span
              className="circulo"
              style={{ backgroundColor: "#A71419" }}
            ></span>
            <span>V: $ {formatmiles(Getvalue("V"))}</span>
          </div>
        </div>

        <div className="barra-progreso-contenedor">
          <div
            className="barra-progreso activa"
            style={{
              width: `${calcPorcentaje(Getvalue("A"), total)}%`,
              backgroundColor: "#4caf50",
            }}
            ref={segmentoARef}
          ></div>
          <div
            className="barra-progreso por-vencer"
            style={{
              width: `${calcPorcentaje(Getvalue("P"), total)}%`,
              backgroundColor: "#ffc107",
            }}
            ref={segmentoPVRef}
          ></div>
          <div
            className="barra-progreso vencida"
            style={{
              width: `${calcPorcentaje(Getvalue("V"), total)}%`,
              backgroundColor: "#A71419",
            }}
            ref={segmentoVRef}
          ></div>
        </div>
      </div>
    </div>
  );
};
